// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__ARpaV","list":"styles_list__3E2gY"};